<template>
  <div class="max-width-limit">
    

    <TheLoader v-if="loading" />
    <MobileNav @changeLang="changeLang" v-show="$route.fullPath && $route.fullPath.includes('logistics')" />
    <div class="k-body-outer-wrapper">
      <div class="k-body-wrapper clearfix k-with-transparent-header k-with-frame">
        <TopNav @changeLang="changeLang" v-show="$route.fullPath && !$route.fullPath.includes('healthcare')" />
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
    <TheFooter />
  </div>
  <div class="main-layer"></div>
</template>

<script>
import TheFooter from "./components/TheFooter.vue";
import TopNav from "./components/TopNav.vue";
import MobileNav from "./components/MobileNav.vue";
import languages from "./languages";
import TheLoader from "./components/TheLoader.vue";

export default {
  components: { TheFooter, MobileNav, TopNav, TheLoader },
  data() {
    return {
      loading: true,
    };
  },
  beforeCreate() {
    let lang = localStorage.getItem("lang");
    if (!lang || lang == "" || lang == "null" || lang == "undefined") {
      localStorage.setItem("lang", "en");
    }
  },
  async mounted() {
    // this.toggleBodyScroll(this.showLandigSelector);
    await this.$store.dispatch("contact/contact");
    this.loading = false;
    this.$nextTick(() => {
      this.checkLayout();
    });

    if (window.AOS) {
      window.AOS.init({
        disable: false,
      });
    } else {
      console.warn('AOS not loaded');
    }

  },
  watch: {
    $route(to, from) {
      if (this.$route.fullPath && this.$route.fullPath.includes('healthcare')) {
        this.showLandigSelector = false;
      }
      // Refresh AOS on route change
      if (window.AOS && typeof window.AOS.refresh === 'function') {
        window.AOS.refresh();
      }
    },
    showLandigSelector(newValue) {
      this.toggleBodyScroll(newValue);
    }
  },
  computed: {

    language() {
      return !localStorage.getItem("lang") ||
        localStorage.getItem("lang") === ""
        ? "en"
        : localStorage.getItem("lang");
    },
    isHealthcareRoute() {
      return this.$route.fullPath && this.$route.fullPath.includes('healthcare');
    }
  },
  provide() {
    return {
      lang: languages[this.language],
      language: this.language,
      photoPath: "https://kurdos-backend.blackace.tech/images/",
    };
  },
  methods: {
    toggleBodyScroll(hide) {
      if (hide) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
    changeLang(lang) {
      if (lang !== localStorage.getItem("lang")) {
        localStorage.setItem("lang", lang);
        this.$router.go();
      }
    },
    checkLayout() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        document.getElementById("app").classList.remove(["rtl", "ku", "ar"]);
      } else if (lang == "ku") {
        document.getElementById("app").classList.add("rtl");
        document.getElementById("app").classList.add("ku");
        document.getElementById("app").classList.remove("ar");
      } else if (lang == "ar") {
        document.getElementById("app").classList.add("rtl");
        document.getElementById("app").classList.add("ar");
        document.getElementById("app").classList.remove("ku");
      }
    },
  },
};
</script>
<style>
.main-layer {
  position: fixed !important;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background: white !important;
  /* z-index: 2000; */
}

.dark .main-layer {
  background: #272727 !important;
}

.max-width-limit {
  max-width: 2560px;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
